import { render, staticRenderFns } from "./ChartOptions.vue?vue&type=template&id=12c54c4b&"
import script from "./ChartOptions.vue?vue&type=script&lang=js&"
export * from "./ChartOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports